<template>
  <b-modal id="edit-user-modal" ref="edit-user-modal" size="lg" v-model="showEditUserModal" @hidden="resetForm"
           :title="modalTitle" centered :hide-footer="true" class="mt-0">
    <template #default>
      <div id="datos-usuario">
        <div class="d-flex justify-content-between">
          <h5>Datos Usuario</h5>
          <h6 class="status pending-status" v-if="editedUser.isLockPending || editedUser.isUnlockPending">
            {{ editedUser.status }}</h6>
          <h6 class="status active-status" v-else-if="editedUser.is_active"> {{ editedUser.status }}</h6>
          <h6 class="status locked-status" v-else> {{ editedUser.status }}</h6>
        </div>
        <b-form>
          <b-row>
            <b-col>
              <b-form-group class="font-size-1rem" label="Nick *">
                <b-form-input :disabled="!isEditable" v-model="editedUser.username"
                              v-validate.immediate="'required|max:255'"
                              name="Nick" :state="errors.has('Nick') ? false : null">
                </b-form-input>
                <span class="error">{{ errors.first('Nick') }}</span>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group class="font-size-1rem" label="Email *">
                <b-form-input :disabled="!isEditable && !editedUser.isUnlockPending" v-model="editedUser.email"
                              v-validate.immediate="'required|max:255|email'"
                              name="Email" :state="errors.has('Email') ? false : null">
                </b-form-input>
                <span class="error">{{ errors.first('Email') }}</span>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group class="font-size-1rem" label="Nombre *">
                <b-form-input :disabled="!isEditable" v-model="editedUser.first_name"
                              v-validate.immediate="'required|max:255'"
                              name="Nombre" :state="errors.has('Nombre') ? false : null">
                </b-form-input>
                <span class="error">{{ errors.first('Nombre') }}</span>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group class="font-size-1rem" label="Apellidos *">
                <b-form-input :disabled="!isEditable" v-model="editedUser.last_name"
                              v-validate.immediate="'required|max:255'"
                              name="Apellidos" :state="errors.has('Apellidos') ? false : null">
                </b-form-input>
                <span class="error">{{ errors.first('Apellidos') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group class="font-size-1rem" label="Metadatos">
                <b-form-input :disabled="!isEditable" v-model="editedUser.metadatos"
                              v-validate.immediate="'max:255'" name="Metadatos"></b-form-input>
                <span class="error">{{ errors.first('Metadatos') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <div id="permissions-selection">
        <div>
          <h5>Selección Permisos</h5>
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex flex-row" id="permissions-selection-type">
            <div class="d-flex flex-row align-items-center" id="permissions-input-manual">
              <input :disabled="!isEditable" type="radio" id="manual" value="manual" v-model="profileSelectionType">
              <label for="manual" class="mb-0">Manualmente</label>
            </div>
            <div class="d-flex flex-row align-items-center" id="permissions-input-user">
              <input :disabled="!isEditable" type="radio" id="byUser" value="byUser" v-model="profileSelectionType">
              <label for="byUser" class="mb-0">Por usuario</label>
              <multiselect
                id="multiselect-user"
                v-model="userSelected"
                :options="usersList"
                :disabled="!isEditable || profileSelectionType === 'manual'"
                label="username"
                track-by="username"
                placeholder=""
                :custom-label="getCustomLabelUser"
                size="sm"
                class="multiselect-user"
                @select="updateUserSelected($event)">
              </multiselect>
              <b-spinner variant="primary" label="Downloading Permissions" v-if="downloadingUserPermissions">
              </b-spinner>
            </div>
          </div>

          <b-list-group class="scroll-permissions w-100">
            <b-list-group-item id="permissions-header" class="d-flex align-items-center position-sticky">
              <span class="flex-30">Grupos</span>
              <div class="d-flex flex-70 text-center">
                <span v-for="(permission, i) in permissionsList" v-bind:key="i" class="text-capitalize flex-1">
                  {{ permission.permiso.toLowerCase() }}
                </span>
              </div>
            </b-list-group-item>

            <b-list-group-item v-for="(role, i) in rolesList" v-bind:key="i" class="d-flex row-padding">
              <span class="text-capitalize flex-30">{{ role.rol.toLowerCase() }}</span>
              <b-form-group class="mb-0 flex-70">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox
                    v-for="permission in permissionsList"
                    :disabled="!isEditable || profileSelectionType === 'byUser'"
                    :key="permission.letra"
                    v-model="editedUser.permisos[role.rol][permission.letra]"
                    class="custom-checkbox"
                    inline>
                  </b-form-checkbox>
                </div>
              </b-form-group>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </template>
    <br>
    <template #modal-footer>
      <b-row>
        <b-col class="text-left">
          <b-button :disabled="editedUser.isLockPending" v-if="editedUser.is_active"
                    @click="updateLockPendingStatus" variant="primary">
            Bloquear
          </b-button>
          <b-button :disabled="editedUser.isUnlockPending" v-else
                    @click="updateUnlockPendingStatus" variant="primary">
            Desbloquear
          </b-button>
        </b-col>
        <b-col class="text-align-right">

          <div class="d-flex align-items-center">
            <b-form-checkbox v-model="editedUser.enviar_notificacion" class="d-block mr-16">
              Enviar notificación
            </b-form-checkbox>
            <b-button :disabled="!editedUser.is_active && !editedUser.isUnlockPending"
                      @click="saveUser" variant="primary">
              Guardar
            </b-button>
          </div>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<style scoped>
.text-align-right {
  text-align: right;
}

.font-size-1rem {
  font-size: 1rem;
}

.flex-30 {
  flex: 30;
}

.flex-70 {
  flex: 70;
}

.flex-1 {
  flex: 1;
}

.mr-16 {
  margin-right: 16px !important;
}

.row-padding {
  padding: .50rem 1.25rem;
}

#permissions-selection {
  padding: 12px 0;
}

#permissions-selection-type {
  margin: 8px 0;
}

#permissions-input-user {
  margin-left: 20px
}

#manual {
  margin-right: 4px;
  height: 20px;
}

#byUser {
  margin-right: 4px;
  height: 20px;
}

#permissions-header {
  background-color: #f7f7f7;
  top: 0;
  z-index: 10;
}

.multiselect-user {
  margin: 0 16px;
  width: 400px;
  z-index: 20;
}

.custom-checkbox {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  padding-left: 2.5rem;
  margin: 0;
}

.status {
  padding: 8px;
  border-radius: 4px;
}

.pending-status {
  color: #96501e;
  background-color: #fff7d0;
  border: 1px solid #ffc107;
}

.active-status {
  color: #3c6518;
  background-color: #e1ffdc;
  border: 1px solid #64bf64;
}

.locked-status {
  color: #911818;
  background-color: #ffdcdc;
  border: 1px solid #ff9a9a;
}

@media screen and (max-height: 800px) {
  .scroll-permissions {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 37vh;
  }
}

@media screen and (min-height: 801px) {
  .scroll-permissions {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 46vh;
  }
}

</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
import EventBus from '../../../../Modules/EventBus';
import GenericUtils from '../../../../utils/generic.utils';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'EditUser',
  props: {
    permisos: Object,
    user: Object
  },
  components: {Loader},
  data () {
    return {
      modalTitle: 'Modificación Usuario',
      editedUser: {
        username: '',
        email: '',
        first_name: '',
        last_name: '',
        metadatos: '',
        is_active: true,
        isLockPending: false,
        isUnlockPending: false,
        permisos: {},
        status: 'Activo',
        enviar_notificacion: false
      },
      profileSelectionType: 'manual',
      userSelected: {},
      usersList: [],
      rolesList: [],
      userData: {},
      permissionsList: [],
      downloadingUserPermissions: false,
      isEditable: true,
      showEditUserModal: false
    };
  },
  mounted: function () {
    if (this.user.id) {
      this.initData();
    }
  },
  watch: {
    profileSelectionType: function (val, oldVal) {
      if (val === 'byUser' && this.userSelected && this.userSelected.id) {
        this.updateUserSelected(this.userSelected);
      }
    }
  },
  methods: {
    initData: function () {
      const self = this;
      Promise.all([
        this.$http.get('roles/', {params: {not_paginated: true}}),
        this.$http.get('permisos/', {params: {not_paginated: true}}),
        this.$http.get('usuarios-activos/', {params: {not_paginated: true}}),
        this.$http.get(`usuarios/${this.user.id}/`)
      ]).then(response => {
        self.rolesList = response[0].data;
        self.permissionsList = response[1].data;
        self.usersList = response[2].data;
        self.userData = response[3].data;

        self.editedUser = GenericUtils.deepCopy(self.userData);
        self.editedUser.status = (self.userData.is_active) ? 'Activo' : 'Bloqueado';
        self.editedUser.enviar_notificacion = false;
        self.isEditable = self.userData.is_active;

        self.showEditUserModal = true;
      });
    },
    getCustomLabelUser: function (option) {
      return (option.id) ? `${option.username} - ${option.first_name} ${option.last_name}` : '';
    },
    updateUserSelected: function (userSelected) {
      this.downloadingUserPermissions = true;
      this.$http.get(`usuarios/${userSelected.id}/`).then(response => {
        this.editedUser.permisos = response.data.permisos;
        this.downloadingUserPermissions = false;
      });
    },
    saveUser: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          EventBus.$emit('show-error-alert', 'El formulario contiene algunos errores, por favor revise los valores introducidos');
        } else {
          if (this.editedUser.isLockPending) {
            this.blockUser();
          } else if (this.editedUser.isUnlockPending) {
            this.unblockUser();
          } else {
            this.updateUser();
          }
        }
      });
    },
    updateLockPendingStatus: function () {
      this.editedUser.isLockPending = true;
      this.editedUser.isUnlockPending = false;
      this.isEditable = false;
      this.editedUser.status = 'Pendiente de bloqueo';
      this.editedUser.email = process.env.SUPPORT_EMAIL;
    },
    updateUnlockPendingStatus: function () {
      this.editedUser.isLockPending = false;
      this.editedUser.isUnlockPending = true;
      this.editedUser.status = 'Pendiente de desbloqueo';
      this.editedUser.email = '';
    },
    updateUser: function () {
      const self = this;
      this.$http.put(`usuarios/${this.user.id}/`, this.editedUser).then(result => {
        // Actualizamos el listado de usuarios de la ventana gestión de usuarios y mostramos mensaje al usuario
        this.$emit('update-users-list');
        EventBus.$emit('show-success-alert', 'Usuario actualizado correctamente');

        // Actualizamos los datos inicales del usuario por los devueltos por el servidor
        self.userData = GenericUtils.deepCopy(result.data);

        // Cerramos el dialogo
        this.$bvModal.hide('edit-user-modal');
      }, reason => {
        console.log(reason);
        EventBus.$emit('show-error-alert', 'Error al actualizar el usuario');
      });
    },
    blockUser: function () {
      this.$http.put(`usuarios/${this.user.id}/bloquear/`, this.editedUser).then(result => {
        this.editedUser.status = 'Bloqueado';
        this.editedUser.isLockPending = false;
        this.editedUser.is_active = false;

        // Actualizamos los datos inicales del usuario por los modificados al bloquear el usuario
        this.userData = GenericUtils.deepCopy(this.editedUser);

        // Actualizamos el listado de usuarios de la ventana gestión de usuarios y mostramos mensaje al usuario
        this.$emit('update-users-list');
        EventBus.$emit('show-success-alert', 'Usuario bloqueado correctamente');
      }, reason => {
        console.log(reason);
        EventBus.$emit('show-error-alert', 'Error al bloquear el usuario');
      });
    },
    unblockUser: function () {
      this.$http.put(`usuarios/${this.user.id}/desbloquear/`, this.editedUser).then(result => {
        this.editedUser.status = 'Activo';
        this.editedUser.isUnlockPending = false;
        this.editedUser.is_active = true;
        this.isEditable = true;

        // Actualizamos los datos inicales del usuario por los modificados al bloquear el usuario
        this.userData = GenericUtils.deepCopy(this.editedUser);

        // Actualizamos el listado de usuarios de la ventana gestión de usuarios y mostramos mensaje al usuario
        this.$emit('update-users-list');
        EventBus.$emit('show-success-alert', 'Usuario desbloqueado correctamente');
      }, reason => {
        console.log(reason);
        EventBus.$emit('show-error-alert', 'Error al desbloquear el usuario');
      });
    },

    resetForm: function () {
      this.editedUser = GenericUtils.deepCopy(this.userData);
      this.editedUser.status = (this.userData.is_active) ? 'Activo' : 'Bloqueado';
      this.editedUser.enviar_notificacion = false;
      this.isEditable = this.userData.is_active;

      this.userSelected = {};
      this.profileSelectionType = 'manual';
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SystemManagement/users-management/edit-user/EditUser.vue